import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const ComplementDataSubtitleForm = styled.h6`
  color: ${colors.textPrimary};
  font-size: 16px;
  line-height: 23px;
  margin-top: 30px;
  font-weight: 600;
`;

